import type { Blocks, QuestionBlock } from '@w/content-blocks'
import { plain } from '../../core/tree-read'

export const switchableQuestionSubtypes = ['sa', 'sc', 'mc', 'la'] as const
export type SwitchableQuestionSubtype = typeof switchableQuestionSubtypes[number]

/** Same semantic-field migration as question-node's subtype conversion; identity and scheduling stay intact. */
export function convertQuestionSubtype(block: QuestionBlock, target: SwitchableQuestionSubtype): QuestionBlock {
  if (block.subtype === target || block.subtype === 'sr') return block
  const texts = block.subtype === 'sa' ? [...block.answer] : block.subtype === 'la' ? [...block.criteria]
    : block.opts.map(option => option.map(item => plain(item)).join(''))
  const count = target === 'sc' || target === 'mc' ? Math.max(2, texts.length) : target === 'sa' ? Math.max(1, texts.length) : texts.length
  while (texts.length < count) texts.push('')
  const next: Record<string, unknown> = { ...block, subtype: target }
  for (const key of ['opts', 'answer', 'strict', 'answerRegexp', 'criteria']) delete next[key]
  if (target === 'sc' || target === 'mc') {
    const opts: Blocks[] = block.subtype === 'sc' || block.subtype === 'mc' ? [...block.opts]
      : texts.map(text => text ? [{ id: '', type: 'text', text }] : [])
    while (opts.length < count) opts.push([])
    next.opts = opts
    next.answer = target === 'sc' ? block.subtype === 'mc' ? block.answer[0] ?? 0 : block.subtype === 'sc' ? block.answer : 0
      : block.subtype === 'sc' ? [block.answer] : block.subtype === 'mc' ? block.answer : block.subtype === 'sa' ? texts.flatMap((text, index) => text ? [index] : []) : []
  } else if (target === 'sa') next.answer = texts
  else { next.criteria = texts.filter(Boolean); delete next.inline }
  return next as unknown as QuestionBlock
}
